import _ from 'lodash';
import axios from 'axios';
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  postMultipartRequest,
  postCustomRequest,
  uploadEncodedFile,
  uploadEncodedFileLarge
} from '../../Common/network-call';
import { INSTANCE_URL, itemCount, APP_API_KEY } from '../../Common/constant';

export const FETCH_MYSESSION_DATA = 'FETCH_MYSESSION_DATA';
export const FETCH_MYSESSION_LIVEQA_DATA = 'FETCH_MYSESSION_LIVEQA_DATA';
export const SHOW_ACCESS_SESSION = 'SHOW_ACCESS_SESSION';
export const OPEN_QA_SESSION = 'OPEN_QA_SESSION';

export function fetchMySessionData(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/mysessions`;
  var body = {
    appuserid: session.userid,
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response mysessions -> ', response);
        dispatch({
          type: FETCH_MYSESSION_DATA,
          payload: {
            data: response.resource,
            count: response.resource.length,
            allaccess: response.allaccess
          }
        });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function makeEmpty_MySessionData() {
  return dispatch => {
    dispatch({ type: FETCH_MYSESSION_DATA, payload: {} });
  };
}

export function fetchliveqa(session, sessionid, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(sessionid=${sessionid})AND(ispublished=1)`
  );
  var orderby = `displayorder%20ASC%2C%20createdon%20DESC`;
  // var orderby = `displayorder%20DESC%2C%20createdon%20ASC`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa?related=appuser_by_questionedby&include_count=true&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_MYSESSION_LIVEQA_DATA,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback({
          success: 1,
          result: { response: data.resource }
        });
      },
      error => {
        // callback({ success: 0, error: error });
      }
    );
  };
}

export function makeEmpty_fetchliveqa() {
  return dispatch => {
    dispatch({ type: FETCH_MYSESSION_LIVEQA_DATA, payload: {} });
  };
}

export function addQue_liveqa(session, resource, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/live_qa`;

  var body = {
    resource: resource
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response addQue_liveqa: ', response);
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function setShowAceessSession(value) {
  return dispatch => {
    dispatch({ type: SHOW_ACCESS_SESSION, payload: value });
  };
}

export function openqa_session(value) {
  return dispatch => {
    dispatch({ type: OPEN_QA_SESSION, payload: value });
  };
}
